import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Col, Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import styles from 'components/Breadcrumbs/breadcrumbs.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import clsx from 'clsx'

const Breadcrumbs = ({ className, links = [] }) => {
  const { sm: isSmallDevice } = useBreakpoint()
  const count = useMemo(() => links.length, [links])
  const filteredLinks = useMemo(
    () => (isSmallDevice && count > 1 ? [...links].splice(-2, 1) : links),
    [links, isSmallDevice, count],
  )

  return (
    <Grid
      className={clsx(styles['breadcrumbs'], className)}
      gap={8}
      direction={'row'}
      alignContent={'center'}
      alignItems={'center'}
    >
      {filteredLinks.map((link, index) => (
        <React.Fragment key={'breadcrumb-segment-' + index}>
          {index !== count - 1 || link.length === 1 ? (
            <Typography
              className={styles['breadcrumbs__link']}
              to={link.to}
              variant={'Body-Forms-20'}
              component={link.to ? Link : 'span'}
              color={isSmallDevice ? 'Label-Fifth' : 'Interface-Sixth'}
            >
              {isSmallDevice ? (
                <Grid gap={8} alignItems={'center'}>
                  <Icon
                    color={'Interface-Seventh'}
                    className={styles['breadcrumbs__arrow']}
                    name={'arrow-left'}
                    size={'m'}
                  />
                  <Col>{link.title}</Col>
                </Grid>
              ) : (
                link.title
              )}
            </Typography>
          ) : (
            <Typography variant={'Body-Forms-Forms-20'} component={'span'} color={'Label-Fifth'}>
              {link.title}
            </Typography>
          )}

          {index !== count - 1 && !isSmallDevice && (
            <Icon
              className={styles['breadcrumbs__arrow']}
              name={'arrow-right'}
              size={'m'}
              color={'Interface-Sixth'}
            />
          )}
        </React.Fragment>
      ))}
    </Grid>
  )
}

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      to: PropTypes.oneOfType([PropTypes.string, undefined]),
    }),
  ),
}

export default Breadcrumbs
